import {
  ArrowTopRightOnSquareIcon,
  ArrowsRightLeftIcon,
  MinusIcon,
  PlusIcon,
} from '@heroicons/react/24/outline'
import type { V3HistoryTransaction } from '@sushiswap/graph-client/data-api'
import { FormattedNumber } from '@sushiswap/ui'
import { format, fromUnixTime } from 'date-fns'
import type { FC } from 'react'
import React from 'react'
import { KATANA_CHAIN_ID } from 'src/config'
import { getEvmChainById } from 'sushi/evm'
import type { Hex } from 'viem'
import { PortfolioInfoRow } from '../portfolio-info-row'

const CATEGORY_CONFIG = {
  SWAP: {
    label: 'Swap',
    Icon: ArrowsRightLeftIcon,
  },
  ADD_LIQUIDITY: {
    label: 'Add Liquidity',
    Icon: PlusIcon,
  },
  REMOVE_LIQUIDITY: {
    label: (
      <>
        <span className="sm:hidden">Remove Liquidity</span>
        <span className="hidden sm:inline">Remove Liq...</span>
      </>
    ),
    Icon: MinusIcon,
  },
} as const

export const PortfolioHistoryTransaction: FC<{
  tx: V3HistoryTransaction
}> = ({ tx }) => {
  const { label, Icon } = CATEGORY_CONFIG[tx.category]
  const chain = getEvmChainById(KATANA_CHAIN_ID)

  const amount0 = Math.abs(Number(tx.amount0))
  const amount1 = Math.abs(Number(tx.amount1))

  const separator = tx.category === 'SWAP' ? ' → ' : ' + '

  return (
    <PortfolioInfoRow
      chainId={KATANA_CHAIN_ID}
      href={chain.getTransactionUrl(tx.txHash as Hex)}
      externalLink
      icon={
        <div className="p-1.5 bg-[#64748B] rounded-full w-7 h-7">
          <Icon className="stroke-2 text-white" />
        </div>
      }
      leftContent={
        <React.Fragment>
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium">{label}</span>
            <div className="flex items-center gap-x-1 text-xs text-muted-foreground">
              {format(fromUnixTime(tx.timestamp), 'yyyy/MM/dd HH:mm')}
              <ArrowTopRightOnSquareIcon className="w-3 h-3" />
            </div>
          </div>
          <div className="text-xs text-muted-foreground overflow-hidden overflow-ellipsis">
            <FormattedNumber number={amount0.toString()} /> {tx.token0Symbol}
            {separator}
            <FormattedNumber number={amount1.toString()} /> {tx.token1Symbol}
          </div>
        </React.Fragment>
      }
      rightContent={null}
    />
  )
}
